// extracted by mini-css-extract-plugin
export default {"btn":"ExpiredHoldsRow_btn__49tb0","table-number-cell":"ExpiredHoldsRow_table-number-cell__SYn7Q","flagged":"ExpiredHoldsRow_flagged__AmVmo","tr":"ExpiredHoldsRow_tr__Ga+Lj"};